import React,{useState,useEffect} from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Checkbox from '@mui/material/Checkbox';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Snackbar from '@mui/material/Snackbar';
import {Item,Owner,AccessLogSummary} from './Inc';
import { FilterItem } from './AccessLogSelectors';
import chartItemName from './ChartItemName';
import chartSummaryName from './ChartSummaryName';
import {getSummaryName} from './ChartSummaryName';
import StoreImg from './StoreImg';
import useStyles from './Styles';

interface AccessLogFilterSelectorsProps {
	owner: Owner;
	open: boolean;
	items: Item[];
	summarys: AccessLogSummary[];
	allSummarys: AccessLogSummary[];
	filters: {
		items:{[key:string]:FilterItem};
		summarys:{[key:string]:FilterItem};
	};
	onClose: (itemNames: {[key:string]:FilterItem}, summaryNames: {[key:string]:FilterItem}) => void;
}

const AccessLogFilterSelectors: React.FC<AccessLogFilterSelectorsProps> = (props) => {
	const classes = useStyles();
	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
	const [states,setStates] = useState({
		tabId:"p1",
		items: [] as Item[],
		isLoading: false,
	});
	const [selected,setSelected] = useState({
		items: Object.keys(props.filters.items),
		summarys: Object.keys(props.filters.summarys),
	});
	const [snack,setSnack] = useState("");

	const handleClose = () => {
		props.onClose(props.filters.items, props.filters.summarys);
	};

	const handleSubmit = () => {
		const items = {} as {[key:string]:FilterItem};
		const summarys = {} as {[key:string]:FilterItem};

		for( let key of selected.items ){
			if( key==="O_0" ){
				items["O_0"] = { key: "O_0", name: "作家" };
			} else if( key==="I_0" ){
				items["I_0"] = { key: "I_0", name: "商品合計" };
			} else if( props.filters.items[key] ){
				items[key] = props.filters.items[key];
			} else {
				const item = props.items.find(x=>("I_"+x.item_id)===key);
				if( item ){
					items[key] = { key: key, name: chartItemName(item), imgId: item.img_id };
				}
			}
		}
		for( let key of selected.summarys ){
			const summary = props.allSummarys.find(x=>x.key===key);
			if( summary ){
				if( summary.key.startsWith("URL") ){
					summarys[key] = { key: key, name: summary.value };
				} else {
					summarys[key] = { key: key, name: getSummaryName(summary.key) };
				}
			} else if( props.filters.summarys[key] ){
				summarys[key] = props.filters.summarys[key];
			}
		}
		//console.log(summarys);
		props.onClose(items, summarys);
	}

	const changeTab = (event: React.ChangeEvent<{}>, newValue: string) =>{
		setStates({...states,tabId:newValue});
	}

	const changeItem = (key:string)=> {
        if( selected.items.includes(key) ){
            setSelected(prevSelected => ({...prevSelected, items: prevSelected.items.filter((value)=>value!==key)}));
        } else {
			if(selected.items.length>=10){
				setSnack("グラフに同時に表示できる商品は10個までです");
				return;
			}
			setSelected(prevSelected => ({...prevSelected, items: [...prevSelected.items, key]}));
        }
    }
	const changeSummary = (key:string)=> {
		if( selected.summarys.includes(key) ){
			setSelected(prevSelected => ({...prevSelected, summarys: prevSelected.summarys.filter((value)=>value!==key)}));
		} else {
			setSelected(prevSelected => ({...prevSelected, summarys: [...prevSelected.summarys, key]}));
		}
	}

	const resetFilters = () => {
		setSelected({
			items: states.tabId==="p1" ? [] : selected.items,
			summarys: states.tabId==="p2" ? [] : selected.summarys,
		});
	}

	const closeSnack = ()=>{
		setSnack("");
	}

	useEffect(() => {
		if (props.open) {
			setSelected({
				items: Object.keys(props.filters.items),
				summarys: Object.keys(props.filters.summarys),
			});
		}
	}, [props.open]);

	return (
		<React.Fragment>
			<Dialog
				open={props.open}
				onClose={handleClose}
				scroll="paper"
				aria-labelledby="scroll-dialog-title"
				aria-describedby="scroll-dialog-description"
				maxWidth="md"
				fullWidth
				fullScreen={fullScreen}
			>
				<DialogTitle id="scroll-dialog-title">
					<Tabs
						value={states.tabId}
						onChange={changeTab}
						indicatorColor="primary"
						textColor="primary"
						variant="fullWidth"
						style={{marginBottom:"0em"}}
					>
						<Tab
							value="p1"
							label="ページ"
							sx={{
								backgroundColor: "#F1F2F3",
								whiteSpace: "nowrap",
								"&.Mui-selected": {
									backgroundColor: "white",
								},
							}}
						/>
						<Tab
							value="p2"
							label="リファラ"
							sx={{
								backgroundColor: "#F1F2F3",
								whiteSpace: "nowrap",
								"&.Mui-selected": {
									backgroundColor: "white",
								},
							}}
						/>
					</Tabs>
				</DialogTitle>
				<DialogContent dividers={false}>
					<DialogContentText
						id="scroll-dialog-description"
					>
					{states.tabId==="p1" &&
					<>
					<Box sx={{marginBottom:"0rem",borderBottom:"1px solid #ccc",paddingBottom:"1rem",textAlign:{xs:"left",sm:"center"},fontSize:{xs:"0.9rem",sm:"1rem"}}}>
						ここで選択したページだけが集計されます
					</Box>
					<Table>
						<TableBody>
							<TableRow key={"O_0"} onClick={()=>changeItem("O_0")} sx={{cursor:'pointer','&:hover':{backgroundColor:'#E5FFEE'}}}>
                                <TableCell className={classes.tableCellDense} align="center" style={{width:"1px",whiteSpace:"nowrap"}}><Checkbox checked={selected.items.includes("O_0")} style={{margin:0,padding:0}} color={selected.items.length<10 ? "primary" : "success"}/></TableCell>
								<TableCell className={classes.tableCellDense} align="center" style={{width:"1px",whiteSpace:"nowrap"}}><StoreImg owner_id={props.owner.owner_id} img_id={props.owner.img_id} thumb={true} className="imgList"/></TableCell>
								<TableCell className={classes.tableCellDense}>
									<span style={{display:'block',fontSize:'0.8rem',color:'teal'}}>作家</span>
									<span>{props.owner.owner_name}</span>
								</TableCell>
							</TableRow>
							<TableRow key={"I_0"} onClick={()=>changeItem("I_0")} sx={{cursor:'pointer','&:hover':{backgroundColor:'#E5FFEE'}}}>
                                <TableCell className={classes.tableCellDense} align="center" style={{width:"1px",whiteSpace:"nowrap"}}><Checkbox checked={selected.items.includes("I_0")} style={{margin:0,padding:0}} color={selected.items.length<10 ? "primary" : "success"}/></TableCell>
								<TableCell className={classes.tableCellDense} align="center" style={{width:"1px",whiteSpace:"nowrap"}}><StoreImg owner_id={props.owner.owner_id} img_id={props.owner.img_id} thumb={true} className="imgList"/></TableCell>
								<TableCell className={classes.tableCellDense}>
									商品合計
								</TableCell>
							</TableRow>
					{props.items.map( (item:Item,index:number)=>{
						const key = "I_"+item.item_id;
						return (
							<TableRow key={key} onClick={()=>changeItem(key)} sx={{cursor:'pointer','&:hover':{backgroundColor:'#E5FFEE'}}}>
                                <TableCell className={classes.tableCellDense} align="center" style={{width:"1px",whiteSpace:"nowrap"}}><Checkbox checked={selected.items.includes(key)} style={{margin:0,padding:0}} color={selected.items.length<10 ? "primary" : "success"}/></TableCell>
								<TableCell className={classes.tableCellDense} align="center" style={{width:"1px",whiteSpace:"nowrap"}}><StoreImg owner_id={props.owner.owner_id} img_id={item.img_id} thumb={true} className="imgList"/></TableCell>
								<TableCell className={classes.tableCellDense}>
									<span className={classes.itemId}>ID:{item.item_id}</span><br/>
									{chartItemName(item)}
								</TableCell>
							</TableRow>
						);
					})}
					{Object.keys(props.filters.items).map((key) => {
						const itemId = parseInt(key.replace("I_", ""), 10);
						const itemName = props.filters.items[key].name;
						const imgId = props.filters.items[key].imgId ?? 0;

						if( key==="O_0" || key==="I_0" ) return null;
						if (props.items.some((x) => x.item_id === itemId)) return null;

						return (
							<TableRow key={key} onClick={()=>changeItem(key)} sx={{cursor:'pointer','&:hover':{backgroundColor:'#E5FFEE'}}}>
                                <TableCell className={classes.tableCellDense} align="center" style={{width:"1px",whiteSpace:"nowrap"}}><Checkbox checked={selected.items.includes(key)} style={{margin:0,padding:0}} color={selected.items.length<10 ? "primary" : "success"}/></TableCell>
								<TableCell className={classes.tableCellDense} align="center" style={{width:"1px",whiteSpace:"nowrap"}}><StoreImg owner_id={props.owner.owner_id} img_id={imgId} thumb={true} className="imgList"/></TableCell>
								<TableCell className={classes.tableCellDense} style={{color:"#ccc"}}>
									<span className={classes.itemId}>ID:{itemId}</span><br/>
									{itemName}
								</TableCell>
							</TableRow>
						)
					})}

						</TableBody>
					</Table>
					</>}

					{states.tabId==="p2" &&
					<>
					<Box sx={{marginBottom:"0rem",borderBottom:"1px solid #ccc",paddingBottom:"1rem",textAlign:{xs:"left",sm:"center"},fontSize:{xs:"0.9rem",sm:"1rem"}}}>
						リファラ（どこからリンクされてたか？）で絞り込みができます<br/>
					</Box>
					<Table>
						<TableBody>
					{props.allSummarys.map( (summary:AccessLogSummary,index:number)=>{
						const key = summary.key;

						//keyがprops.summarysに存在しない場合は、文字色を灰色にする
						const textColor = !props.summarys.some(x=>x.key===key) ? "#ccc" : "inherit";

						return (
							<TableRow key={key} onClick={()=>changeSummary(key)} sx={{cursor:'pointer','&:hover':{backgroundColor:'#E5FFEE'}}}>
                                <TableCell className={classes.tableCellDense} align="center" style={{width:"1px",whiteSpace:"nowrap"}}><Checkbox checked={selected.summarys.includes(key)} style={{margin:0,padding:0}} color="primary"/></TableCell>
								<TableCell className={classes.tableCellDense} style={{color: textColor}}>
									{chartSummaryName(summary)}
								</TableCell>
							</TableRow>
						);
					})}
						</TableBody>
					</Table>
					</>}
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button variant="outlined" onClick={resetFilters} sx={{ mr: "auto" }} startIcon={<CloseIcon />}>リセット</Button>
					<Button onClick={handleClose}>閉じる</Button>
					<Button variant="contained" color="primary" onClick={handleSubmit}>決定</Button>
				</DialogActions>
			</Dialog>
			<Snackbar
				anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
				open={snack!==""}
				autoHideDuration={5000}
				onClose={closeSnack}
				message={snack}
			/>
		</React.Fragment>
	);
}

export default AccessLogFilterSelectors;